import type { ChangeBrief, EvidencePacket } from "../../shared/schema";
import { CheckIcon, FileIcon, PhoneIcon, ShieldIcon } from "../icons";

interface EvidenceRailProps {
  change: ChangeBrief;
  packet: EvidencePacket | null;
  onPreview: () => void;
  onOpenPacket: () => void;
}

export function EvidenceRail({ change, packet, onPreview, onOpenPacket }: EvidenceRailProps) {
  const evidenceRows = [
    ["Owner consent record", "Added"],
    ["Interview transcript", packet ? "Added" : "Not added"],
    ["Impact assessment", packet ? "Ready" : "Not added"],
  ];
  const transcript = packet?.transcript ?? [
    { speaker: "CALL-E", text: "Hello, this is CALL-E." },
    { speaker: "CALL-E", text: "I’m calling on behalf of the data platform team about a proposed change to “orders.customer_email” renamed to “customer_contact”." },
  ];

  return (
    <aside className="evidence-rail">
      <section className="owner-card">
        <h2>Owner contact</h2>
        <span className="field-label">Primary phone</span>
        <strong>+1 ••• ••• 0148</strong>
        <div className="consent-line"><span className="consent-icon"><CheckIcon /></span><span>Explicit consent confirmed<small>Aug 15, 2026 10:24 UTC by {change.owner.name}</small></span></div>
      </section>

      <button className="preview-call" type="button" onClick={onPreview}><PhoneIcon />{packet ? "Review call" : "Preview call"}</button>

      <section className={`safety-panel${packet ? " is-complete" : ""}`}>
        <ShieldIcon />
        <div><strong>{packet ? "Dry interview complete" : "No call placed"}</strong><p>{packet ? "Demo evidence is ready for human review." : "Preview the questions first. Nothing dials until a person explicitly approves."}</p></div>
      </section>

      <hr />
      <section className="evidence-packet">
        <h2>Evidence packet</h2>
        <div className="evidence-list">
          {evidenceRows.map(([label, status]) => (
            <div key={label}><FileIcon /><span>{label}</span><small className={status !== "Not added" ? "ready" : ""}>{status}</small></div>
          ))}
        </div>
      </section>

      <section className="transcript-preview">
        <div><h3>Transcript preview {packet ? "(dry run)" : "(script)"}</h3><span>{packet ? "1:16" : "0:00"}</span></div>
        <div className="transcript-box">
          {transcript.slice(0, 4).map((line, index) => <p key={`${line.speaker}-${index}`}><b>{line.speaker}:</b> {line.text}</p>)}
          {transcript.length > 4 ? <p>…</p> : null}
        </div>
      </section>

      <div className="mobile-packet-action">
        <button type="button" disabled={!packet} onClick={onOpenPacket}>Create approval packet</button>
      </div>
    </aside>
  );
}
